<template lang="pug">
div
  el-form-item(label="默认值")
    el-radio-group(v-model="defaultDeptType")
      el-radio(v-for="{ id, cnName } in options", :key="id", :label="id") {{ cnName }}
    el-button(v-if="isAll", @click="addDept", size="mini") 添加部门
  .box(v-if="isAll")
    el-tag(v-for="{ deptId, deptName } in defaultDept", :key="deptId", size="small", closable, @close="remove(deptId)") {{ deptName }}
  el-divider 字段关联
  field-setting(v-if="!single", key="deptId", v-model="mapDeptIdsTo", v-bind="$props", label="关联部门ID")
  field-setting(v-model="mapDeptNamesTo", key="deptName", v-bind="$props", label="关联部门名称")
  field-setting(v-model="mapFullNamesTo", key="fullName", v-bind="$props", label="关联部门全名")
  div(v-if="!single") 提示：如果有多个值，则会以逗号隔开
</template>
<script>
import { DEPT_ENUM } from "./index.js";
import UserList from "@/CommonDP/components/userList/index.vue";
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";

export default {
  components: { UserList },
  mixins: [settingMixin],
  props: {
    optionModel: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      visible: false,
      options: [
        { id: DEPT_ENUM.all, cnName: "指定部门" },
        { id: DEPT_ENUM.cur_dept, cnName: "当前用户所在部门" },
        { id: DEPT_ENUM.cur_main, cnName: "当前用户主部门" }
      ]
    };
  },
  computed: {
    ...mapVFOptions("defaultDeptType", "defaultDept", "mapDeptIdsTo", "mapDeptNamesTo", "mapFullNamesTo", "single"),
    isAll() {
      return this.defaultDeptType === DEPT_ENUM.all;
    }
  },
  methods: {
    async addDept() {
      const { defaultDept } = this;
      const deptList = (defaultDept || []).map(({ deptId, deptName }) => ({ id: deptId, name: deptName, deptId, deptName, selectName: deptName, selectCode: "Dept" }));
      const _data = await openMember({ codePri: ["Dept"], usersList: deptList });
      this.defaultDept = _data.map(({ id, name }) => ({ deptId: id, deptName: name }));
    },
    async remove(id) {
      await this.$confirm("确认删除?", "警告", { type: "warning" });
      const { defaultDept } = this;
      const data = defaultDept.filter((dept) => dept.deptId !== id);
      this.defaultDept = data || [];
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px 8px;
  .el-tag {
    margin: 2px 2px;
  }
}
</style>
